/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
    {
        url: "/dashboard",
        name: "Dashboard",
        slug: "dashboard",
        icon: "HomeIcon",
        i18n: "Dashboard",
        prefix: '/dashboard',
    },
    {
        header: "Super Admin",
        icon: "PackageIcon",
        i18n: "Super Admin",
        rule: 'admin',
        items: [
            {
                url: "/admin/manage-organization",
                name: "navMenu.organization",
                slug: "manage-organization",
                icon: "GlobeIcon",
                i18n: "navMenu.organization",
            },
            {
                url: "/admin/manage-camera",
                name: "Camera",
                slug: "admin-manage-camera",
                icon: "CameraIcon",
                i18n: "Organization",
            },
            // {
            //   url: "/admin/manage-master-work-shift",
            //   name: "Ca làm việc",
            //   slug: "manage-master-work-shift",
            //   icon: "GlobeIcon",
            //   rule: 'organization',
            //   i18n: "Organization",
            // },
            {
                url: null,
                name: 'navMenu.servicePack',
                i18n: 'Manage',
                icon: 'PackageIcon',
                rule: 'admin',
                submenu: [
                    {
                        url: "/admin/permission-function",
                        name: "navMenu.funcAuthority",
                        slug: "permission-function-admin",
                        icon: "SidebarIcon",
                        i18n: "navMenu.funcAuthority",
                    },
                    {
                        url: "/admin/organization-package",
                        name: "navMenu.servicePack",
                        slug: "organization-package",
                        icon: "PackageIcon",
                        i18n: "navMenu.servicePack",
                    },
                    {
                        url: "/admin/history-register-package",
                        name: "navMenu.requestHistory",
                        slug: "history-register-package",
                        icon: "PackageIcon",
                        i18n: "navMenu.requestHistory",
                    },
                ]
            },
            {
                url: null,
                name: 'navMenu.manageEmployee',
                i18n: 'navMenu.manageEmployee',
                icon: 'UsersIcon',
                rule: 'organization_user',
                prefix: '/user/menu-manager-employee',
                submenu: [
                    {
                        url: "/user/organization-info",
                        name: "navMenu.organizationInformation",
                        slug: "user-organization-info",
                        icon: "GlobeIcon",
                        i18n: "navMenu.organizationInformation",
                        rule: 'organization_user',
                    },
                    {
                        url: "/apps/email",
                        name: "License",
                        slug: "license",
                        icon: "CreditCardIcon",
                        i18n: "License",
                    },
                    {
                        url: "/user/organization-branch",
                        name: "navMenu.branch",
                        slug: "user-organization-branch",
                        icon: "GitBranchIcon",
                        i18n: "navMenu.branch",
                        rule: 'organization_user',
                    },
                    {
                        url: "/user/manage-department",
                        name: "navMenu.department",
                        slug: "user-manage-department",
                        icon: "",
                        i18n: 'navMenu.department',
                        rule: 'organization_user',
                    },
                    {
                        url: "/user/manage-employee",
                        name: "navMenu.personnel",
                        slug: "user-manage-employee",
                        icon: "UsersIcon",
                        i18n: "navMenu.personnel",
                        rule: 'organization_user',
                    },
                    {
                        url: "/user/manage-leave",
                        name: "navMenu.leave",
                        slug: "user-manage-leave",
                        icon: "CalendarIcon",
                        i18n: "navMenu.leave",
                        rule: 'organization_user',
                    },
                    {
                        url: "/user/manage-permision",
                        name: "Quản lý quyền",
                        slug: "user-manage-permision",
                        icon: "CalendarIcon",
                        i18n: "navMenu.managePermision",
                        rule: 'organization_user',
                    },
                    {
                        url: "/user/manage-position",
                        name: "Quản lý chức vụ",
                        slug: "user-manage-position",
                        icon: "CalendarIcon",
                        i18n: "navMenu.managePosition",
                        rule: 'organization_user',
                    }
                    // {
                    //   url: "/user/manage-stranger",
                    //   name: "Phát hiện xâm nhập",
                    //   slug: "manage-report-stranger",
                    //   icon: "FlagIcon",
                    //   i18n: "Report",
                    // },
                    // {
                    //   url: "/user/manage-crowded",
                    //   name: "Cảnh báo tụ tập",
                    //   slug: "manage-report-crowded",
                    //   icon: "AlertTriangleIcon",
                    //   i18n: "Report",
                    // },
                    // {
                    //   url: "/user/manage-face-id",
                    //   name: "Chấm công Face ID",
                    //   slug: "user-manage-face-id",
                    //   icon: "SmileIcon",
                    //   i18n: "FaceId",
                    // },
                ]
            },
            {
                url: null,
                name: 'navMenu.resourceManagement',
                i18n: 'navMenu.resourceManagement',
                icon: 'TrelloIcon',
                rule: 'organization_user',
                prefix: '/user/menu-resource',
                submenu: [{
                    url: "/user/manage-multipurpose-room",
                    name: "navMenu.functionRoom",
                    slug: "user-manage-manage-multipurpose-room",
                    icon: "EyeIcon",
                    i18n: "navMenu.functionRoom",
                }]
            },

            {
                url: null,
                name: 'navMenu.checkIn',
                i18n: 'navMenu.checkIn',
                icon: 'CheckCircleIcon',
                rule: 'organization_user',
                prefix: '/user/menu-manage-wifi',
                submenu: [
                    {
                        url: "/user/manage-wifi",
                        name: "navMenu.wifiCheckIn",
                        slug: "user-manage-wifi",
                        icon: "WifiIcon",
                        i18n: "navMenu.wifiCheckIn",
                    },
                    {
                        url: "/user/manage-qr-code",
                        name: "navMenu.qrCheckIn",
                        slug: "user-manage-qr-code",
                        icon: "QRIcon",
                        i18n: "navMenu.qrCheckIn",
                    },
                    {
                        url: "/user/manage-work-shift-branch",
                        name: "navMenu.shift",
                        slug: "manage-branch-work-shift",
                        icon: "SettingsIcon",
                        i18n: "navMenu.shift",
                    },
                    {
                        url: "/user/manage-work-shift-by-day",
                        name: "navMenu.shiftDaybyday",
                        slug: "manage-work-shift-by-day",
                        icon: "ClockIcon",
                        i18n: "navMenu.shiftDaybyday",
                    },
                    {
                        url: "/user/over-time-manager",
                        name: "navMenu.workMore",
                        slug: "user-over-time-manager",
                        icon: "ClockIcon",
                        i18n: "navMenu.workMore",
                    },
                    {
                        url: "/user/remote-timekeeping",
                        name: "navMenu.remoteTimekeeping",
                        slug: "remote-timekeeping",
                        icon: "UserIcon",
                        i18n: "navMenu.remoteTimekeeping",
                    },
                    {
                        url: "/user/time-keeping",
                        name: "navMenu.historyCheckIn",
                        slug: "time-keeping",
                        icon: "UserIcon",
                        i18n: "navMenu.historyCheckIn",
                    },
                    {
                        url: "/user/confirm-time-keeping",
                        name: "Xác nhận chấm công",
                        slug: "personnel",
                        icon: "ClipboardIcon",
                        i18n: "Organization",
                    },
                    {
                        url: "/user/update-in-out",
                        name: "navMenu.complaintLetter",
                        slug: "update-in-out",
                        icon: "CalendarIcon",
                        i18n: "navMenu.complaintLetter",
                    },
                    {
                        url: "/user/in-out-history",
                        name: "navMenu.historyInOut",
                        slug: "personnel",
                        icon: "SidebarIcon",
                        i18n: "navMenu.historyInOut",
                    }
                ]
            },
            {
                url: null,
                name: 'navMenu.policy',
                i18n: 'navMenu.policy',
                icon: 'BookIcon',
                rule: 'organization_user',
                prefix: '/user/menu-policy',
                submenu: [
                    {
                        url: "/user/manage-policy",
                        name: "policy.leave",
                        slug: "user-manage-policy",
                        i18n: "policy.leave",
                        icon: ''
                    },
                    {
                        url: "/user/manage-holiday",
                        name: "policy.holiday",
                        slug: "user-manage-holiday",
                        i18n: "policy.holiday",
                        icon: ''
                    }
                ]
            },

            {
                url: null,
                name: 'navMenu.manageNew',
                i18n: 'navMenu.manageNew',
                icon: 'NavigationIcon',
                rule: 'organization_user',
                prefix: '/user/menu-internal-communications',
                submenu: [
                    {
                        url: "/user/manage-news",
                        name: "navMenu.mNew",
                        slug: "user-manage-news",
                        icon: "BriefcaseIcon",
                        i18n: "navMenu.mNew",
                    },
                    {
                        url: "/user/manage-notification",
                        name: "navMenu.notification",
                        slug: "user-manage-notification",
                        icon: "GiftIcon",
                        i18n: "navMenu.notification",
                    },
                    {
                        url: "/user/manage-classroom-manager",
                        name: "navMenu.classroomManager",
                        slug: "user-manage-classroom-manager",
                        icon: "BriefcaseIcon",
                        i18n: "navMenu.classroomManager",
                    },
                ]
            },

            {
                url: null,
                name: 'navMenu.manageDevice',
                i18n: 'navMenu.manageDevice',
                icon: 'PackageIcon',
                rule: 'organization_user',
                prefix: '/user/menu-asset',
                submenu: [
                    {
                        url: "/user/manage-device",
                        name: "navMenu.listDevice",
                        slug: "manage-device",
                        icon: "BriefcaseIcon",
                        i18n: "navMenu.listDevice",
                    },
                    {
                        url: "/user/assign-device-history",
                        name: "navMenu.historyDevice",
                        slug: "assign-device-history",
                        icon: "ClockIcon",
                        i18n: "navMenu.historyDevice",
                    },
                ]
            },

            {
                url: null,
                name: 'navMenu.manageEquipment',
                i18n: 'navMenu.manageEquipment',
                icon: 'ArchiveIcon',
                rule: 'organization_user',
                prefix: '/user/menu-item',
                submenu: [
                    {
                        url: "/user/manage-equipment",
                        name: "navMenu.listEquipment",
                        slug: "manage-equipment",
                        icon: "BriefcaseIcon",
                        i18n: "navMenu.listEquipment",
                    },
                    {
                        url: "/user/edit-equipmen",
                        name: "navMenu.editEquipment",
                        slug: "manage-equipment",
                        icon: "GiftIcon",
                        i18n: "navMenu.editEquipment",
                    },

                    {
                        url: "/user/assign-equipment-history",
                        name: "navMenu.historyEquipment",
                        slug: "assign-equipment-history",
                        icon: "ClockIcon",
                        i18n: "navMenu.historyEquipment",
                    },
                ]
            },
            {
                url: null,
                name: 'navMenu.assign',
                i18n: 'navMenu.assign',
                icon: 'ClipboardIcon',
                rule: 'organization_user',
                prefix: '/user/menu-assign',
                submenu: [
                    {
                        url: "/user/assign-project",
                        name: "navMenu.project",
                        slug: "user-assign-project",
                        icon: "BriefcaseIcon",
                        i18n: "navMenu.project",
                    },
                    {
                        url: "/user/assign-tasks",
                        name: "navMenu.tasks",
                        slug: "user-assign-tasks",
                        icon: "BriefcaseIcon",
                        i18n: "navMenu.tasks",
                    },

                ]
            },

            //Document
            {
                url: "/user/document",
                name: "Tài liệu nội bộ",
                slug: "document",
                icon: "LayersIcon",
                i18n: "Tài liệu nội bộ",
                prefix: '/user/menu-document',
                // rule: 'organization_user'
            },

            //settings Hrm
            {
                url: null,
                name: 'navMenu.settingsHrm',
                i18n: 'navMenu.settingsHrm',
                icon: 'SettingsIcon',
                rule: 'organization_user',
                prefix: '/user/menu-settings',
                submenu: [
                    {
                        url: "/user/settings-hrm-project",
                        name: "navMenu.project",
                        slug: "user-settings-hrm",
                        icon: "BriefcaseIcon",
                        i18n: "navMenu.project",
                    },
                    {
                        url: "/user/settings-hrm-email",
                        name: "navMenu.email",
                        slug: "user-settings-hrm-email",
                        icon: "BriefcaseIcon",
                        i18n: "navMenu.email",
                    },
                ]
            },
        ]
    },
]
